import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "un-recharge-modal-content" }
const _hoisted_2 = { class: "un-recharge-modal-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/icon/warning_icon.png",
  alt: "",
  class: "warning"
}, null, -1)
const _hoisted_4 = { class: "un-recharge-modal-body" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = {
  key: 0,
  class: "text",
  style: {"margin-bottom":"22px"}
}
const _hoisted_7 = {
  key: 1,
  class: "text",
  style: {"margin-bottom":"22px"}
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 4,
  class: "text"
}
const _hoisted_11 = {
  key: 5,
  class: "text"
}
const _hoisted_12 = {
  key: 6,
  class: "fun"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/icon/move_icon.png",
  alt: ""
}, null, -1)
const _hoisted_14 = {
  href: "https://s.theckb.com/ja/help/d2c-charge#5",
  target: "_blank"
}
const _hoisted_15 = { class: "un-recharge-modal-footer" }

import { moneyAddCurrency } from '@/util/useYan'
import bus from '@/util/useBus'
import { isJA, useRtfix, useSite2Station } from '@/store'
import { useRouter } from 'vue-router'
import { t } from '@/plugins/i18n'
import { ref } from 'vue'
import { getWallet } from '@/apis/user'
import { useStore } from 'vuex'
import { getCustomerWalletList } from '@/apis/fund'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const dialogVisible = ref(false)
const close = () => {
  dialogVisible.value = false
}
const recharge: any = ref(0)
const unCheckMoney: any = ref(0)
// 1 主账户有余额 2 主账户无余额，审核中有余额
const status = ref(1)
bus.on('openUnRechargeModal', async ({ currency, unCheckCnyAmt }: { currency?: string, unCheckCnyAmt?: any }) => {
  dialogVisible.value = true
  unCheckMoney.value = moneyAddCurrency(unCheckCnyAmt ?? 0, currency ?? 'CNY')
  getCustomerWalletList({
    stationCode: useSite2Station(),
    currencyCode: currency ?? 'CNY'
  }).then((res: any) => {
    const { data } = res
    const availableAmount = data.find?.((e: any) => e.accountType === 1)?.availableAmount ?? 0
    recharge.value = moneyAddCurrency(availableAmount, currency ?? 'CNY')
    status.value = availableAmount === 0 && unCheckCnyAmt > 0 ? 2 : 1
  })
})

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
    title: "Tips",
    "custom-class": "un-recharge-modal",
    "show-close": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_unref(t)('下单失败2')), 1),
          _createElementVNode("img", {
            src: "https://static-s.theckb.com/BusinessMarket/Client/icon/close_icon.png",
            alt: "",
            class: "close",
            onClick: close
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('您的订单需要“子店铺口座”的余额支付')), 1),
          (status.value === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(t)('目前，主账户中有审核中的余额，但是还不能转账。')), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(t)('目前，主账户中有余额，但尚未转入子店铺口座。')), 1)),
          (status.value === 2)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "text",
                innerHTML: _unref(t)('主账户余额：X元').replace('X', `<span>${recharge.value}</span>`) + `(${_unref(t)('审核中')}：${unCheckMoney.value})`
              }, null, 8, _hoisted_8))
            : (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "text",
                innerHTML: _unref(t)('主账户余额：X元（可转账）').replace('X', `<span>${recharge.value}</span>`)
              }, null, 8, _hoisted_9)),
          (status.value === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(t)('审核结束后可以转账')), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(t)('请先从以下按钮进行转账，然后再下单。')), 1)),
          (_unref(isJA)())
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("span", null, _toDisplayString(_unref(t)('转账方法')), 1),
                _createElementVNode("a", _hoisted_14, _toDisplayString(_unref(t)('点这里')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", {
            class: "btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(_unref(useRtfix)('CustomerFund'))))
          }, _toDisplayString(status.value === 2 ? _unref(t)('确认账户余额') : _unref(t)('去转账给子店铺')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})